import React, { useState } from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import AdminSidebar from '../../components/AdminSidebar';
import AdminHeader from '../../components/AdminHeader';

const SIDEBAR_W  = 240;
const SIDEBAR_IC = 60;

export default function AdminLayout() {
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem('mtaani_sidebar_collapsed') === 'true'
  );

  const toggle = () =>
    setCollapsed((c) => {
      const next = !c;
      localStorage.setItem('mtaani_sidebar_collapsed', String(next));
      return next;
    });

  const sideW = collapsed ? SIDEBAR_IC : SIDEBAR_W;

  return (
    <Box sx={{ display: 'flex', height: '100vh', overflow: 'hidden', bgcolor: 'background.default' }}>
      {/* Permanent sidebar */}
      <AdminSidebar collapsed={collapsed} onToggle={toggle} width={sideW} expandedWidth={SIDEBAR_W} collapsedWidth={SIDEBAR_IC} />

      {/* Main area */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          minWidth: 0,
          transition: 'none',
        }}
      >
        {/* Topbar */}
        <AdminHeader collapsed={collapsed} onMenuToggle={toggle} />

        {/* Page content */}
        <Box
          component="main"
          sx={{
            flex: 1,
            overflow: 'auto',
            bgcolor: 'background.default',
            p: { xs: 2, sm: 2.5, md: 3 },
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
